module.exports = __webpack_public_path__ + "media/images/icons/outlined/tag-661bc7540822e45baa3926a2bb672153.svg";